import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-all-job-chains',
  templateUrl: './all-job-chains.component.html',
  styleUrls: ['./all-job-chains.component.scss']
})
export class AllJobChainsComponent implements OnInit {
  visibleSidebar2;
  products: Product[];
  items: MenuItem[];
  events1: any[];

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
  this.events1 = [
    {
      
      class: "step-completed",
      iconclass:"step-completed-icon"
    },
    {
      class: "step-next",
      iconclass:"step-next-icon"
    },
    {
      class: "step-pending",
      iconclass:"step-pending-icon"
    }
  ];
}

}
